// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__Q0IEk","footer":"ModalUpdate_footer__1gD_d"};